<template>
  <div class="card custom-card mt-4">
    <div class="container-fluid">
      <div class="table-controls mt-3 d-flex">
        <div class="controls-wrap d-flex w-100">
          <!-- Job -->
          <!-- <select class="form-control" @change="handleEmployerJobs($event)" v-model="selectedJob">
            <option v-for="job in getManagerJobsDropdown" :key="job.id" :value="{ ...job }">
              {{ job.job_name }}, {{ job.city.name }}
            </option>
          </select> -->

          <v-select
            class="select-field"
            v-model="selectedJob"
            @input="handleEmployerJobs($event)"
            :options="getManagerJobsDropdown"
            placeholder="Job"
            inputId="manager-pipeline-job-select"
            label="job_name"
            :reduce="job => job"
            :clearable="true"
            :multiple="false"
          >
            <template #option="{ job_name, city }"> {{ job_name }}, {{ city.name }}</template>
            <template #selected-option="{ job_name, city }">
              {{ job_name }}, {{ city.name }}
            </template>
            <template v-slot:no-options>
              <div style="opacity: 0.5">
                {{ getJobListMsg }}
              </div>
            </template>
          </v-select>
        </div>
      </div>

      <div class="groups pipeline d-flex mt-4">
        <Spinner :isLoading="isLoading" />
        <div class="group">
          <PipelineList headerColor="color-not-contacted" title="NOT CONTACTED">
            <Container
              @drag-start="e => onDrag('drag start', e)"
              group-name="1"
              :get-child-payload="getChildPayload1"
              @drop="onDrop('notContactedList', $event, { newStage: 'not_contacted' })"
            >
              <Draggable v-for="(item, idx) in notContactedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <div class="media-left d-flex">
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                          class="img"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </div>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'manager_candidate_id',
                                params: { manager_candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span>
                              <span
                                ><i class="far fa-clock"></i> {{ countDays(item.created_at) }}</span
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-contacted" title="CONTACTED">
            <Container
              @drag-start="e => onDrag('drag start', e)"
              group-name="1"
              :get-child-payload="getChildPayload2"
              @drop="onDrop('contactedList', $event, { newStage: 'contacted' })"
            >
              <Draggable v-for="(item, idx) in contactedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <div class="media-left d-flex">
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                          class="img"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </div>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'manager_candidate_id',
                                params: { manager_candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span>
                              <span
                                ><i class="far fa-clock"></i> {{ countDays(item.created_at) }}</span
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-interviewing" title="INTERVIEWING">
            <Container
              @drag-start="e => onDrag('drag start', e)"
              group-name="1"
              :get-child-payload="getChildPayload3"
              @drop="onDrop('interviewingList', $event, { newStage: 'interviewing' })"
            >
              <Draggable v-for="(item, idx) in interviewingList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <div class="media-left d-flex">
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                          class="img"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </div>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'manager_candidate_id',
                                params: { manager_candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span>
                              <span
                                ><i class="far fa-clock"></i> {{ countDays(item.created_at) }}</span
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-offered-employment" title="OFFERED EMPLOYMENT">
            <Container
              @drag-start="e => onDrag('drag start', e)"
              group-name="1"
              :get-child-payload="getChildPayload4"
              @drop="onDrop('offeredEmploymentList', $event, { newStage: 'offered' })"
            >
              <Draggable v-for="(item, idx) in offeredEmploymentList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <div class="media-left d-flex">
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                          class="img"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </div>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'manager_candidate_id',
                                params: { manager_candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span>
                              <span
                                ><i class="far fa-clock"></i> {{ countDays(item.created_at) }}</span
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-employed" title="EMPLOYED">
            <Container
              @drag-start="e => onDrag('drag start', e)"
              group-name="1"
              :get-child-payload="getChildPayload5"
              @drop="onDrop('employedList', $event, { newStage: 'employed' })"
            >
              <div v-for="(item, idx) in employedList" :key="idx">
                <div class="draggable-item" style=" cursor: not-allowed;">
                  <PipelineItem>
                    <div class="media">
                      <div class="media-left d-flex">
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                          class="img"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </div>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'manager_candidate_id',
                                params: { manager_candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span>
                              <span
                                ><i class="far fa-clock"></i> {{ countDays(item.created_at) }}</span
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </div>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-no-longer-interested" title="NO LONGER INTERESTED">
            <Container
              @drag-start="e => onDrag('drag start', e)"
              group-name="1"
              :get-child-payload="getChildPayload6"
              @drop="onDrop('noLongerInterestedList', $event, { newStage: 'no_longer_interested' })"
            >
              <Draggable v-for="(item, idx) in noLongerInterestedList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <div class="media-left d-flex">
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                          class="img"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </div>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'manager_candidate_id',
                                params: { manager_candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span>
                              <span
                                ><i class="far fa-clock"></i> {{ countDays(item.created_at) }}</span
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>

        <div class="group">
          <PipelineList headerColor="color-not-in-consideration" title="NOT IN CONSIDERATION">
            <Container
              @drag-start="e => onDrag('drag start', e)"
              group-name="1"
              :get-child-payload="getChildPayload7"
              @drop="onDrop('notInConsiderationList', $event, { newStage: 'not_in_consideration' })"
            >
              <Draggable v-for="(item, idx) in notInConsiderationList" :key="idx">
                <div class="draggable-item">
                  <PipelineItem>
                    <div class="media">
                      <div class="media-left d-flex">
                        <img
                          v-if="
                            item.photo !== null &&
                              item.photo !== 'null' &&
                              item.photo !== 'default.png'
                          "
                          :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                          alt="avatar preview"
                          class="img"
                        />
                        <img
                          v-else
                          src="https://jobshark.eu/img/comstream.svg"
                          alt="avatar preview"
                        />
                      </div>
                      <div class="media-body">
                        <div class="overview">
                          <div class="name">
                            <router-link
                              :to="{
                                name: 'manager_candidate_id',
                                params: { manager_candidate_id: item.candidate_id },
                              }"
                            >
                              {{ item.first_name }}
                              {{ item.last_name }}
                            </router-link>
                          </div>
                          <div class="icons">
                            <span>
                              <span
                                ><i class="far fa-clock"></i> {{ countDays(item.created_at) }}</span
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </PipelineItem>
                </div>
              </Draggable>
            </Container>
          </PipelineList>
        </div>
      </div>

      <div class="no-data-message h-100" v-show="false">
        <p>No data to display</p>
      </div>

      <!-- Add diff devices containers -->
      <!-- Mobile accordtion Starts Here -->
      <div
        id="carouselExample-mobile-tablet"
        ref="carousel"
        class="carousel slide mobile-tablet"
        data-ride="false"
        data-wrap="false"
        data-interval="0"
      >
        <div class="indexes">
          <ul class="list-inline">
            <li @click="goToSlide(1)" class="list-inline-item">
              <div class="content">
                <span class="color-not-contacted"></span> {{ notContactedList.length }}
              </div>
            </li>
            <li @click="goToSlide(2)" class="list-inline-item">
              <div class="content">
                <span class="color-contacted"></span> {{ contactedList.length }}
              </div>
            </li>
            <li @click="goToSlide(3)" class="list-inline-item">
              <div class="content">
                <span class="color-interviewing"></span> {{ interviewingList.length }}
              </div>
            </li>
            <li @click="goToSlide(4)" class="list-inline-item">
              <div class="content">
                <span class="color-offered-employment"></span> {{ offeredEmploymentList.length }}
              </div>
            </li>
            <li @click="goToSlide(5)" class="list-inline-item">
              <div class="content">
                <span class="color-employed"></span> {{ employedList.length }}
              </div>
            </li>
            <li @click="goToSlide(6)" class="list-inline-item">
              <div class="content">
                <span class="color-no-longer-interested"></span> {{ noLongerInterestedList.length }}
              </div>
            </li>
            <li @click="goToSlide(7)" class="list-inline-item last">
              <div class="content">
                <span class="color-not-in-consideration"></span> {{ notInConsiderationList.length }}
              </div>
            </li>
          </ul>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="group">
              <PipelineList headerColor="color-not-contacted" title="NOT CONTACTED">
                <div v-for="(item, idx) in notContactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-contacted" title="CONTACTED">
                <div v-for="(item, idx) in contactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-interviewing" title="INTERVIEWING">
                <div v-for="(item, idx) in interviewingList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-offered-employment" title="OFFERED EMPLOYMENT">
                <div v-for="(item, idx) in offeredEmploymentList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-employed" title="EMPLOYED">
                <div v-for="(item, idx) in employedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-no-longer-interested" title="NO LONGER INTERESTED">
                <div v-for="(item, idx) in noLongerInterestedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-not-in-consideration" title="NOT IN CONSIDERATION">
                <div v-for="(item, idx) in notInConsiderationList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExample-mobile-tablet"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExample-mobile-tablet"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>

          <span class="sr-only">Next</span>
        </a>
      </div>
      <!-- Mobile accordtion ENDS Here -->

      <!-- Tablet slider START -->
      <div
        id="carouselExample-tablet"
        class="carousel slide tablet"
        data-ride="carousel"
        data-wrap="false"
        data-interval="0"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="group">
              <PipelineList headerColor="color-contacted" title="NOT CONTACTED">
                <div v-for="(item, idx) in notContactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-not-contacted" title="CONTACTED">
                <div v-for="(item, idx) in contactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-interviewing" title="INTERVIEWING">
                <div v-for="(item, idx) in interviewingList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-offered-employment" title="OFFERED EMPLOYMENT">
                <div v-for="(item, idx) in offeredEmploymentList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-employed" title="EMPLOYED">
                <div v-for="(item, idx) in employedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-no-longer-interested" title="NO LONGER INTERESTED">
                <div v-for="(item, idx) in noLongerInterestedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-not-in-consideration" title="NOT IN CONSIDERATION">
                <div v-for="(item, idx) in notInConsiderationList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExample-tablet"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExample-tablet"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>

          <span class="sr-only">Next</span>
        </a>
      </div>
      <!-- Tablet slider END -->

      <!-- Mid screen slider START -->
      <div
        id="carouselExample-mid"
        class="carousel slide mid-screen"
        data-ride="carousel"
        data-wrap="false"
        data-interval="0"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="group">
              <PipelineList headerColor="color-contacted" title="NOT CONTACTED">
                <div v-for="(item, idx) in notContactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-not-contacted" title="CONTACTED">
                <div v-for="(item, idx) in contactedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-interviewing" title="INTERVIEWING">
                <div v-for="(item, idx) in interviewingList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>

          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-offered-employment" title="OFFERED EMPLOYMENT">
                <div v-for="(item, idx) in offeredEmploymentList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-employed" title="EMPLOYED">
                <div v-for="(item, idx) in employedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
            <div class="group">
              <PipelineList headerColor="color-no-longer-interested" title="NO LONGER INTERESTED">
                <div v-for="(item, idx) in noLongerInterestedList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>
          <div class="carousel-item">
            <div class="group">
              <PipelineList headerColor="color-not-in-consideration" title="NOT IN CONSIDERATION">
                <div v-for="(item, idx) in notInConsiderationList" :key="idx">
                  <div class="draggable-item">
                    <PipelineItem>
                      <div class="media">
                        <div class="media-left d-flex">
                          <img
                            v-if="
                              item.photo !== null &&
                                item.photo !== 'null' &&
                                item.photo !== 'default.png'
                            "
                            :src="`https://jobshark.eu/storage/admincandidateavatars/${item.photo}`"
                            alt="avatar preview"
                            class="img"
                          />
                          <img
                            v-else
                            src="https://jobshark.eu/img/comstream.svg"
                            alt="avatar preview"
                          />
                        </div>
                        <div class="media-body">
                          <div class="overview">
                            <div class="name">
                              <router-link
                                :to="{
                                  name: 'manager_candidate_id',
                                  params: { manager_candidate_id: item.candidate_id },
                                }"
                              >
                                {{ item.first_name }}
                                {{ item.last_name }}
                              </router-link>
                            </div>
                            <div class="icons">
                              <span>
                                <span
                                  ><i class="far fa-clock"></i>
                                  {{ countDays(item.created_at) }}</span
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </PipelineItem>
                  </div>
                </div>
              </PipelineList>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExample-mid"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExample-mid"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>

          <span class="sr-only">Next</span>
        </a>
      </div>
      <!-- Tablet slider END -->
    </div>

    <portal to="move-candidate">
      <CustomMainModal @close="onCloseAddJobModal" v-show="showModal" modalSize="modal-xs">
        <template v-slot:header>
          <h5>Employed</h5>
        </template>
        <p v-if="showModal" class="text-center">
          Please confirm that
          <strong
            >{{ temp.dropResult.payload.first_name }}
            {{ temp.dropResult.payload.last_name }}</strong
          >
          should be move to Employed.
        </p>
        <div class="d-flex align-items-center justify-content-center">
          <button
            :disabled="isLoadingPipe"
            @click="confirmMove"
            type="button"
            class="btn btn-secondary me-2"
          >
            Move
          </button>
          <button :disabled="isLoadingPipe" @click="undoMove" type="button" class="btn btn-primary">
            Cancel
          </button>
        </div>
      </CustomMainModal>
    </portal>
    <portal-target name="move-candidate"></portal-target>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Container, Draggable /* , smoothDnD */ } from 'vue-smooth-dnd';
import { applyDrag, listMapper } from '@/utils/helpers';

import PipelineList from '../../Manager/Pipeline/ManagerPipelineList';
import PipelineItem from '../../Manager/Pipeline/ManagerPipelineItem.vue';
/* import Avatar from '../../common/AvatarPreviewOnly'; */

import CustomMainModal from '../../Modals/CustomMainModal';
/* import AddCandidateBtnModal from '../Candidates/ManagerAddCandidateBtnModal'; */

import { stagesMixin } from '../../../mixins/stagesMixin';
import { errorService } from '../../../services/errorService';
import { MESSAGES } from '../../../constants';
import titleMixin from '../../../mixins/titleMixin';
// import { localStorageHelper } from '@/utils/helpers';

/* import format from 'date-fns/format';
import moment from 'moment'; */

export default {
  components: {
    Container,
    Draggable,
    CustomMainModal,
    /* AddCandidateBtnModal, */
    PipelineList,
    PipelineItem,
    /* Avatar, */
  },
  mixins: [stagesMixin, titleMixin],
  title() {
    return 'Pipelines | Jobshark';
  },
  data: () => ({
    temp: {},
    selectedJob: null,
    showModal: false,
    /* DnD */
    notContactedList: [],
    contactedList: [],
    interviewingList: [],
    offeredEmploymentList: [],
    employedList: [],
    noLongerInterestedList: [],
    notInConsiderationList: [],
    getCollection: null,
    /* Snapshot */
    tempNotContactedList: [],
    tempContactedList: [],
    tempInterviewingList: [],
    tempOfferedEmploymentList: [],
    tempEmployedList: [],
    tempNoLongerInterestedList: [],
    tempNotInConsiderationList: [],
    isLoading: true,
    isLoadingPipe: false,
    counts: {},
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      /* 'updatePipeline',
      'retrieveCandidates',
      'retrieveDndPipelines', */
      'retrieveManagerJobsDropdownPipe',
      'retrieveManagerPipelines',
      'retrieveManagerPipelinesForJob',
      'updateManagerDndPipelines',
      'retrieveManagerUserProfile',
    ]),
    goToSlide(slideIndex) {
      const carouselElement = this.$refs.carousel;
      const bootstrapCarousel = new bootstrap.Carousel(carouselElement, {
        interval: 0, // Disable automatic sliding
        wrap: false, // Prevent the carousel from wrapping around
      });
      bootstrapCarousel.to(slideIndex - 1);
    },

    countDays(date) {
      const targetDate = new Date(date);
      const currentDate = new Date();
      const timeDifference = currentDate - targetDate;
      const daysPassed = timeDifference / (1000 * 60 * 60 * 24);

      return `${Math.floor(daysPassed)} days`;
    },
    initDndData(data) {
      console.log('initDndData: ', data);

      data.forEach(item => {
        if (item.stage == 102) {
          this.notContactedList.push(item);
        } else if (item.stage == 103) {
          this.contactedList.push(item);
        } else if (item.stage == 104) {
          this.interviewingList.push(item);
        } else if (item.stage == 106) {
          this.offeredEmploymentList.push(item);
        } else if (item.stage == 107) {
          this.employedList.push(item);
        } else if (item.stage == 108) {
          this.noLongerInterestedList.push(item);
        } else if (item.stage == 109) {
          this.notInConsiderationList.push(item);
        }
      });
    },
    clearDndLists() {
      this.notContactedList = [];
      this.contactedList = [];
      this.interviewingList = [];
      this.offeredEmploymentList = [];
      this.employedList = [];
      this.noLongerInterestedList = [];
      this.notInConsiderationList = [];
    },
    handleEmployerJobs() {
      this.goToSlide(1);
      this.clearDndLists();

      this.retrieveManagerPipelinesForJob(this.selectedJob.id)
        .then(response => {
          this.isLoading = false;
          this.initDndData(response.data);
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    showModalForEmployed(collection, dropResult, stage) {
      this.showModal = true;
      this.temp = {
        collection: collection,
        dropResult: dropResult,
        stage: stage,
      };
    },
    onCloseAddJobModal() {
      this.showModal = false;
      this.showModal = false;
      this.temp = {};
      this.canUpdate = false;
    },

    confirmMove() {
      this.isLoadingPipe = true;
      const { collection, dropResult, stage } = this.temp;
      this.updateManagerDndPipelines({
        pipeline_id: dropResult.payload.pipeline_id,
        stage: stage.newStage,
      }).then(() => {
        this.isLoadingPipe = false;
        this.showModal = false;
        this.temp = {};
        this.canUpdate = false;
        this.$toasted.show(
          `<div>You have moved <span>${dropResult.payload.first_name} ${
            dropResult.payload.last_name
          }</span> to <span>${listMapper(collection)}</span></div>`,
          {
            position: 'bottom-right',
            singleton: true,
            duration: 7000,
            keepOnHover: true,
            theme: 'toasted-primary',
            action: [
              {
                icon: 'fa-times',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
      });
    },

    undoMove() {
      this.showModal = false;
      this.temp = {};
      this.canUpdate = false;
      this.notContactedList = this.tempNotContactedList;
      this.contactedList = this.tempContactedList;
      this.interviewingList = this.tempInterviewingList;
      this.offeredEmploymentList = this.tempOfferedEmploymentList;
      this.employedList = this.tempEmployedList;
      this.noLongerInterestedList = this.tempNoLongerInterestedList;
      this.notInConsiderationList = this.tempNotInConsiderationList;
    },
    onDrag(...params) {
      console.log('onDrag: ', ...params);

      (this.tempNotContactedList = this.notContactedList),
        (this.tempContactedList = this.contactedList),
        (this.tempInterviewingList = this.interviewingList),
        (this.tempOfferedEmploymentList = this.offeredEmploymentList),
        (this.tempEmployedList = this.employedList),
        (this.tempNoLongerInterestedList = this.noLongerInterestedList),
        (this.tempNotInConsiderationList = this.notInConsiderationList);
    },
    /* DnD */
    onDrop(collection, dropResult, stage) {
      this[collection] = applyDrag(this[collection], dropResult);

      if (dropResult.addedIndex !== null) {
        console.log('dropResult payload: ', dropResult);

        if (collection === 'employedList') {
          this.showModalForEmployed(collection, dropResult, stage);
          return false;
        }

        this.updateManagerDndPipelines({
          pipeline_id: dropResult.payload.pipeline_id,
          stage: stage.newStage,
        });

        this.$toasted.clear();
        this.$toasted.show(
          `<div>You have moved <span>${dropResult.payload.first_name} ${
            dropResult.payload.last_name
          }</span> to <span>${listMapper(collection)}</span></div>`,
          {
            position: 'bottom-right',
            singleton: true,
            duration: 7000,
            keepOnHover: true,
            theme: 'toasted-primary',
            action: [
              {
                text: 'Undo',
                onClick: (e, toastObject) => {
                  this.notContactedList = this.tempNotContactedList;
                  this.contactedList = this.tempContactedList;
                  this.interviewingList = this.tempInterviewingList;
                  this.offeredEmploymentList = this.tempOfferedEmploymentList;
                  this.employedList = this.tempEmployedList;
                  this.noLongerInterestedList = this.tempNoLongerInterestedList;
                  this.notInConsiderationList = this.tempNotInConsiderationList;

                  toastObject.goAway(0);
                },
              },
              {
                icon: 'fa-times',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            ],
          },
        );
      }
    },
    getChildPayload1(index) {
      return this.notContactedList[index];
    },
    getChildPayload2(index) {
      return this.contactedList[index];
    },
    getChildPayload3(index) {
      return this.interviewingList[index];
    },
    getChildPayload4(index) {
      return this.offeredEmploymentList[index];
    },
    getChildPayload5(index) {
      console.log('employed child :', this.employedList);
      return this.employedList[index];
    },
    getChildPayload6(index) {
      return this.noLongerInterestedList[index];
    },
    getChildPayload7(index) {
      return this.notInConsiderationList[index];
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', ['getManagerJobsDropdown', 'getManagerUserProfile']),
    getJobListMsg() {
      return MESSAGES.managerNoOPtionsMessage;
    },
  },
  watch: {
    selectedJob() {
      localStorage.managerPipelineSelectedJob = JSON.stringify(this.selectedJob);
    },
  },
  mounted() {
    this.retrieveManagerUserProfile();

    this.retrieveManagerJobsDropdownPipe()
      .then(res => {
        this.isLoading = false;
        if (this.localStoragePlugin.has('managerPipelineSelectedJob')) {
          this.selectedJob = this.localStoragePlugin.get('managerPipelineSelectedJob');
        } /* else if (this.getManagerJobsDropdown.length) {
          console.log('getManagerJobsDropdown length is 0');
          this.selectedJob = { job_name: 'Select job' };
          
        } */ else {
          const placeholderJob = { city: [], country: [], id: '', job_name: 'Select Job' };

          res.data.length ? (this.selectedJob = res.data[0]) : placeholderJob;
          this.localStoragePlugin.set('managerPipelineSelectedJob', this.selectedJob);
          //  this.handleEmployerJobs();
        }
      })
      .then(() => {
        this.handleEmployerJobs();
      })
      .catch(err => {
        this.$toasted.error(errorService(err), {
          theme: 'bubble',
          icon: 'fa-unlock-alt',
          position: 'bottom-right',
          duration: 5000,
        });
      });
  },
};
</script>

<style lang="scss" scoped>
.select-field {
  width: 35%;
}
.groups {
  position: relative;
}
.img {
  width: 40px !important;
  height: 40px !important;
  border-radius: 100%;
  flex-shrink: 0;
  object-fit: cover;
}
.first {
  position: relative;
  background: none !important;
  border: none !important;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
}
.pipeline {
  .smooth-dnd-container {
    min-height: calc(100vh - 228px);
  }

  .group {
    flex-shrink: 0;
    width: 14.1%;
    margin-right: 3px;
  }
  .icons {
    color: #666;
    font-size: 10px;
    margin-top: 5px;
  }
}
.media-left {
  position: relative;
  width: 40px;
  height: 40px;
  margin-right: 12px;
}

/* .card-body:nth-child(even) {
  background-color: red;
} */

.carousel {
  /*  background: red; */
  display: none;
}

.accordion {
  display: none !important;
}

@media only screen and (max-width: 1251px) {
  .select-field {
    width: 100%;
  }
  .card {
    overflow: hidden;
    margin-left: 23px !important;
    margin-right: 23px !important;
  }
  .mid-screen {
    display: block !important;
    .group {
      width: 33%;
      display: inline-block;
    }
  }
  .tablet {
    display: none !important;
  }

  .mobile-tablet {
    display: none !important;
  }
  .accordion {
    display: none !important;
  }
  .accordion {
    display: none !important;
  }
  .carousel {
    display: block;
    margin: 20px 2px 15px 0;

    .carousel-item {
      height: calc(100vh - 155px);
      overflow-y: auto;
      .media-body {
        .name {
          font-size: 16px;
        }
        .icons {
          font-size: 14px;
          color: #666;
        }
      }
    }
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      height: 100px;
      width: 100px;
      outline: black;
      background-size: 100%, 100%;
      background-image: none;
      font-style: normal;
      font-variant: normal;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
    }
    .carousel-control-prev {
      left: -65px;
    }
    .carousel-control-next {
      right: -65px;
    }

    .carousel-control-next-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f105';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }

    .carousel-control-prev-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f104';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }
  }

  .mobile-fixed {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 54px;
    height: 54px;
    font-size: 28px;
    border-radius: 50%;
    z-index: 9;
    line-height: 34px;
  }

  .pipeline {
    display: none !important;
    padding-bottom: 30px;
    height: calc(100vh - 145px);

    .smooth-dnd-container {
      min-height: calc(100vh - 228px) !important;
    }

    .drag-col {
      width: 100%;
    }

    .card {
      margin-top: 12px !important;
    }
  }

  .controls-wrap {
    width: 100% !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    overflow: hidden;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    overflow: hidden;
  }

  .mid-screen {
    display: none !important;
  }
  .tablet {
    display: block !important;
    .group {
      width: 50%;
      display: inline-block;
    }
  }

  .mobile-tablet {
    display: none !important;
  }
  .accordion {
    display: none !important;
  }
  .accordion {
    display: none !important;
  }
  .carousel {
    display: block;
    margin: 20px 2px 15px 0;

    .carousel-item {
      height: calc(100vh - 155px);
      overflow-y: auto;
      .media-body {
        .name {
          font-size: 16px;
        }
        .icons {
          font-size: 14px;
          color: #666;
        }
      }
    }
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      height: 100px;
      width: 100px;
      outline: black;
      background-size: 100%, 100%;
      background-image: none;
      font-style: normal;
      font-variant: normal;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
    }
    .carousel-control-prev {
      left: -55px;
    }
    .carousel-control-next {
      right: -55px;
    }

    .carousel-control-next-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f105';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }

    .carousel-control-prev-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f104';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }
  }
  .mobile-fixed {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 54px;
    height: 54px;
    font-size: 28px;
    border-radius: 50%;
    z-index: 9;
    line-height: 34px;
  }
  .pipeline {
    display: none !important;
    padding-bottom: 30px;
    height: calc(100vh - 145px);
    .smooth-dnd-container {
      height: calc(100vh - 228px);
      overflow: hidden;
      overflow-y: auto;
    }
    .drag-col {
      width: 100%;
    }
    .card {
      margin-top: 12px !important;
    }
  }

  .controls-wrap {
    width: 100% !important;
  }
}
@media only screen and (max-width: 576px) {
  .indexes {
    .list-inline {
      display: flex;
      justify-content: center;
      li {
        font-size: 14px;
        margin-right: 20px;
        .content {
          display: flex;
          align-items: center;
          span {
            display: inline-block;
            width: 18px;
            height: 18px;
            border-radius: 100%;
            margin-right: 5px;
          }
        }
        &.last {
          margin-right: 0;
        }
      }
    }
  }
  .mobile-tablet {
    display: block !important;
    .group {
      width: 95%;
      display: block;
      margin: 0 auto;
    }
  }
  .card {
    overflow: hidden;
    overflow-y: auto !important;
  }
  .custom-card {
    height: calc(100vh - 65px) !important;
  }

  .accordion {
    display: block !important;
    margin-top: 20px;
  }

  .mid-screen {
    display: none !important;
  }
  .tablet {
    display: none !important;
  }
  .mobile {
    display: block !important;
  }
  .media-body {
    .name {
      font-size: 16px;
    }
    .icons {
      font-size: 14px;
      color: #666;
    }
  }

  .mobile-fixed {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 54px;
    height: 54px;
    font-size: 28px;
    border-radius: 50%;
    z-index: 9;
    line-height: 34px;
  }
  .pipeline {
    display: none !important;
    padding-bottom: 30px;
    height: calc(100vh - 145px);
    .smooth-dnd-container {
      height: calc(100vh - 228px);
      overflow: hidden;
      overflow-y: auto;
    }
    .drag-col {
      width: 100%;
    }
    .card {
      margin-top: 12px !important;
    }
  }

  .controls-wrap {
    width: 100% !important;
  }

  .carousel {
    display: block;
    margin: 20px 2px 15px 0;

    .carousel-item {
      height: calc(100vh - 155px);
      overflow-y: auto;
      .media-body {
        .name {
          font-size: 16px;
        }
        .icons {
          font-size: 14px;
          color: #666;
        }
      }
    }
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      height: 100px;
      width: 100px;
      outline: black;
      background-size: 100%, 100%;
      background-image: none;
      font-style: normal;
      font-variant: normal;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
    }
    .carousel-control-prev {
      left: -36px;
    }
    .carousel-control-next {
      right: -36px;
    }

    .carousel-control-next-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f105';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }

    .carousel-control-prev-icon:after {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f104';
      font-size: 55px;
      color: rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
